export const isRunningInAppWebview = (): boolean =>
  typeof window !== 'undefined' &&
  !!(window as { ReactNativeWebView?: unknown }).ReactNativeWebView;
